export function bgBodyManager(link) {
    const body = document.body;
    const bgNavMobile = document.querySelector("#nav-mobile-bg");

    if (!body || !bgNavMobile) return;

    const backgrounds = {
        "#faf7f0": ["", "login", "notifications"],
        "#f1ece0": ["documents", "news", "profile"]
    };

    for (const [color, routes] of Object.entries(backgrounds)) {
        if (routes.includes(link)) {
            body.style.background = color;
            bgNavMobile.style.background = color;
            return;
        }
    }
}
